module.exports = __webpack_public_path__ + "img/sb2.f238922a.jpg";